export default __webpack_public_path__ + "static/media/remove-all.3a41f64a.svg";